var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmalogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1884.83 668.46",
    width: 1884.83,
    height: 668.46,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fffffe;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-7);}.cls-9{clip-path:url(#clip-path-9);}.cls-10{clip-path:url(#clip-path-11);}.cls-11{clip-path:url(#clip-path-13);}.cls-12{clip-path:url(#clip-path-15);}.cls-13{clip-path:url(#clip-path-17);}.cls-14{clip-path:url(#clip-path-18);}.cls-15{clip-path:url(#clip-path-20);}.cls-16{clip-path:url(#clip-path-22);}.cls-17{clip-path:url(#clip-path-24);}.cls-18{clip-path:url(#clip-path-26);}.cls-19{clip-path:url(#clip-path-28);}.cls-20{clip-path:url(#clip-path-30);}.cls-21{clip-path:url(#clip-path-31);}.cls-22{clip-path:url(#clip-path-33);}.cls-23{clip-path:url(#clip-path-35);}.cls-24{clip-path:url(#clip-path-37);}.cls-25{clip-path:url(#clip-path-39);}.cls-26{clip-path:url(#clip-path-41);}.cls-27{clip-path:url(#clip-path-43);}.cls-28{fill:#ffb500;}.cls-29{clip-path:url(#clip-path-45);}.cls-30{clip-path:url(#clip-path-47);}.cls-31{clip-path:url(#clip-path-49);}.cls-32{clip-path:url(#clip-path-51);}.cls-33{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.59,82.13V79.89c0-5.56-2.25-10.18-7-10.18-5.29,0-7.67,4.1-7.67,8.33,0,18.66,40.21,9.52,40.21,44.05,0,20.12-11.77,29.1-33.47,29.1-20.37,0-31.75-7-31.75-26.58V121.3H26.72v2.24c0,8.08,3.3,11,8.06,11,5,0,7.94-4,7.94-9.11C42.72,106.74,4.1,116,4.1,82.54,4.1,63.48,14.28,53,35.05,53c21.43,0,30.56,8.86,30.56,29.1h-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1851.96,
    y: -383.54,
    width: 15779.97,
    height: 37192.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "85.97 75.79 67.45 75.79 67.45 54.88 129.09 54.88 129.09 75.79 110.57 75.79 110.57 149.34 85.97 149.34 85.97 75.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.54,54.88h31l23,94.46H167.32l-2.51-16.54H145.23l-2.51,16.54h-26.2ZM155.15,74.2h-.26l-6.75,40.08h13.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "199.47 75.79 180.95 75.79 180.95 54.88 242.59 54.88 242.59 75.79 224.07 75.79 224.07 149.34 199.47 149.34 199.47 75.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "244.83 54.88 300.78 54.88 300.78 75 269.43 75 269.43 91.13 298.8 91.13 298.8 110.45 269.43 110.45 269.43 129.24 301.97 129.24 301.97 149.34 244.83 149.34 244.83 54.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "339.13 54.88 374.31 54.88 384.24 110.84 384.5 110.84 394.42 54.88 429.61 54.88 429.61 149.34 406.59 149.34 406.59 78.97 406.33 78.97 393.23 149.34 375.5 149.34 362.41 78.97 362.14 78.97 362.14 149.34 339.13 149.34 339.13 54.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "438.33 54.88 494.28 54.88 494.28 75 462.93 75 462.93 91.13 492.29 91.13 492.29 110.45 462.93 110.45 462.93 129.24 495.47 129.24 495.47 149.34 438.33 149.34 438.33 54.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502.47,54.88h35.72c28.44,0,29.9,22.5,29.9,47.24s-1.46,47.22-29.9,47.22H502.47Zm24.61,76.74H532c9.53,0,10.72-4,10.72-29.5S541.5,72.61,532,72.61h-4.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 575.48,
    y: 54.88,
    width: 24.6,
    height: 94.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M646.51,83.59c0-10.71-2-13.88-6.75-13.88-7.54,0-8.33,6.87-8.33,32.41s.79,32.4,8.33,32.4c6.08,0,7.41-5.28,7.41-23.14H671v7c0,26.47-15.48,32.81-31.22,32.81-27.65,0-33.73-13.88-33.73-49.07C606,66,614.23,53,639.76,53c22.23,0,30.56,11.65,30.56,29.9v5.95H646.51V83.59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M693.33,54.88h30.95l23,94.46H721.1l-2.51-16.54H699l-2.51,16.54H670.3Zm15.6,19.32h-.26l-6.75,40.08h13.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "749.4 54.88 774 54.88 774 129.24 804.3 129.24 804.3 149.34 749.4 149.34 749.4 54.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1240.51,54.88h31l23,94.46h-26.2l-2.51-16.54h-19.58l-2.51,16.54h-26.19Zm15.61,19.32h-.27l-6.75,40.08h13.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1333.36,82.13V79.89c0-5.56-2.25-10.18-7-10.18-5.29,0-7.67,4.1-7.67,8.33,0,18.66,40.22,9.52,40.22,44.05,0,20.12-11.77,29.1-33.47,29.1-20.38,0-31.75-7-31.75-26.58V121.3h23.81v2.24c0,8.08,3.31,11,8.06,11,5,0,8-4,8-9.11,0-18.67-38.62-9.41-38.62-42.87,0-19.06,10.17-29.51,31-29.51,21.42,0,30.55,8.86,30.55,29.1h-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1402.4,82.13V79.89c0-5.56-2.26-10.18-7-10.18-5.3,0-7.68,4.1-7.68,8.33,0,18.66,40.22,9.52,40.22,44.05,0,20.12-11.78,29.1-33.47,29.1-20.38,0-31.75-7-31.75-26.58V121.3h23.81v2.24c0,8.08,3.31,11,8.07,11,5,0,7.94-4,7.94-9.11,0-18.67-38.63-9.41-38.63-42.87,0-19.06,10.18-29.51,31-29.51,21.43,0,30.55,8.86,30.55,29.1h-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1433.73,
    y: 54.88,
    width: 24.6,
    height: 94.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1503.84,82.13V79.89c0-5.56-2.25-10.18-7-10.18-5.29,0-7.67,4.1-7.67,8.33,0,18.66,40.2,9.52,40.2,44.05,0,20.12-11.76,29.1-33.46,29.1-20.37,0-31.76-7-31.76-26.58V121.3H1488v2.24c0,8.08,3.31,11,8.07,11,5,0,7.94-4,7.94-9.11,0-18.67-38.63-9.41-38.63-42.87,0-19.06,10.19-29.51,31-29.51,21.43,0,30.55,8.86,30.55,29.1h-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1548.54 75.79 1530.02 75.79 1530.02 54.88 1591.66 54.88 1591.66 75.79 1573.14 75.79 1573.14 149.34 1548.54 149.34 1548.54 75.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1603.44,54.88h31l23,94.46h-26.2l-2.51-16.54h-19.58l-2.51,16.54h-26.2ZM1619,74.2h-.27L1612,114.28h13.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1659.51 54.88 1687.02 54.88 1702.9 113.09 1703.16 113.09 1703.16 54.88 1726.18 54.88 1726.18 149.34 1699.2 149.34 1682.79 91 1682.52 91 1682.52 149.34 1659.51 149.34 1659.51 54.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1773.52,83.59c0-10.71-2-13.88-6.74-13.88-7.54,0-8.34,6.87-8.34,32.41s.8,32.4,8.34,32.4c6.09,0,7.41-5.28,7.41-23.14H1798v7c0,26.47-15.48,32.81-31.22,32.81-27.65,0-33.74-13.88-33.74-49.07C1733,66,1741.25,53,1766.78,53c22.22,0,30.56,11.65,30.56,29.9v5.95h-23.82V83.59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1804.87 54.88 1860.82 54.88 1860.82 75 1829.47 75 1829.47 91.13 1858.83 91.13 1858.83 110.45 1829.47 110.45 1829.47 129.24 1862.01 129.24 1862.01 149.34 1804.87 149.34 1804.87 54.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,184.83v21H857.75a164.3,164.3,0,0,1-4-21H0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1862.91,184.83H1179.85a162.59,162.59,0,0,1-4,21h687v-21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M901.63,182.33a75.14,75.14,0,0,0,7.68-9.67c1.24-1.74,2.36-3.33,3.43-4.67,6.5-8.09,13.66-10.12,18.53-10.41,7-.38,13.8,2.44,19.45,8,1.85,1.83,5.47,5.59,9.16,9.44,4,4.12,8.88,9.23,10.15,10.39,1.55,1.43,3.07,1.6,3.91,1.29.29-.1.88-.31,1.08-1.66,1.1-7.54,14.48-94.52,16-101.91,1.91-9.17,10.33-15.29,20.18-14.93,9.64.36,17.19,6.81,18.36,15.69.7,5.43,3.94,46.8,8.09,100.33,1.32,16.91,2.58,33.22,3.37,43.17.81-4.52,1.7-9.33,2.49-13.61s1.49-8.08,1.85-10.26c3-17.43,12.39-22.69,19.27-26.52a32.2,32.2,0,0,0,7.68-5.3c6.4-6.38,10.31-10.87,17.7-19.6a25.28,25.28,0,0,1,17.25-9.14c6.93-.51,14.12,2,20.11,7.2,5.7,4.92,13.92,12.62,21.17,19.41,4.56,4.25,8.51,7.95,10.71,9.91,5,4.41,12.48,5.34,17.89,5.34h2.71a166.22,166.22,0,0,0,1.32-20.46,164.36,164.36,0,1,0-327.4,20.46h36.89c4.25,0,9.7-1.27,11-2.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1134.17,184.94c-6.76-6.32-15.18-14.19-20.56-18.85a7.37,7.37,0,0,0-4.73-2.13,4.32,4.32,0,0,0-2.83,1.77c-6.94,8.19-11.56,13.57-18.86,20.87a52.14,52.14,0,0,1-12.31,8.79c-5.61,3.13-7.5,4.18-8.77,11.66-.38,2.23-1.09,6.1-1.92,10.56-1.36,7.39-3,16.44-3.93,22.26-1.62,10.3-9.7,17.38-19.74,17.38h-.44c-10.1-.21-18-7.52-19.16-17.79-.27-2.35-1.72-20.94-4.25-53.6-2.31-29.91-5.29-68.16-6.9-87.41-4,24.52-12.63,80.77-13.93,89.66A22.59,22.59,0,0,1,981,206.54c-8.49,3-18.14.87-25.18-5.62-1.63-1.5-5.27-5.27-11.08-11.31-3.54-3.68-7-7.29-8.76-9-1.55-1.52-2.8-2-3.45-2s-1.87.73-3.34,2.56c-.83,1-1.68,2.27-2.64,3.63A94.07,94.07,0,0,1,916.67,197c-8.23,8.41-23.1,8.84-26,8.84H857.75a164.39,164.39,0,0,0,318.14,0c-12.42-.23-23-3.86-30.58-10.59-2.29-2-6.41-5.87-11.14-10.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51",
    transform: "translate(10.96 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762.13,361.62h-1L734.21,515H789Zm1096.45-76.7v74.64H1744.35v59.92h107V491.2h-107v69.73h118.56v74.65h-208.2V284.92Zm-383.73,0L1511,549.14h1l36.19-264.22h95.55l-74.32,350.66H1453.61l-72.86-350.66Zm-116,0V635.58h-87.67V284.92Zm-224.47,50.33V560.93h114.89v74.65H1041V370.84A212.49,212.49,0,0,0,1134.36,335.25ZM823.92,284.92l85.62,350.66H812.11l-9.35-61.39H729.93l-9.35,61.39h-96l84.15-350.66Zm-417.85,0,37.25,207.74h1l37.25-207.74H613.67V635.58H527.25V374.3h-1L477.09,635.58H410.54L361.37,374.3h-1V635.58H274V284.92Zm-287.24,0q59.65,0,86.31,25.68t26.65,82H146.7v-8.32q0-15.66-6.35-26.67t-19.56-11q-14.67,0-21.52,9.53a35.72,35.72,0,0,0-6.85,21.29q0,17.13,11,27.16t27.62,17.37q16.63,7.35,35.7,14.92a159.2,159.2,0,0,1,35.7,19.83,98.14,98.14,0,0,1,27.63,32.05q11,19.8,11,51.63,0,55.78-31.78,81t-91.94,25.2q-28.36,0-50.12-4.65T30.56,625.74A72.87,72.87,0,0,1,7.82,595.65Q0,577.07,0,549.65V537.42H88v8.32q0,22.51,8.32,31.55t21.51,9.06q14.19,0,21.76-9.79t7.58-24q0-17.12-10.51-27.15T110.27,508.3q-15.88-7.1-34.47-14.43a151.2,151.2,0,0,1-34.48-19.09A93.8,93.8,0,0,1,14.92,444Q4.4,424.87,4.4,394q0-53.34,28.36-81.24T118.83,284.92Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2.9,
    y: 53.03,
    width: 87.13,
    height: 120.08
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 67.45,
    y: 54.88,
    width: 83.56,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 116.52,
    y: 54.88,
    width: 98.91,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 180.95,
    y: 54.88,
    width: 83.56,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.83,
    y: 54.88,
    width: 79.06,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.13,
    y: 54.88,
    width: 112.4,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.33,
    y: 54.88,
    width: 79.06,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 502.47,
    y: 54.88,
    width: 87.53,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 575.48,
    y: 54.88,
    width: 46.52,
    height: 116.38
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 606.03,
    y: 53.03,
    width: 86.87,
    height: 120.08
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 670.3,
    y: 54.88,
    width: 98.91,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 749.4,
    y: 54.88,
    width: 76.81,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1217.49,
    y: 54.88,
    width: 98.91,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1293.67,
    y: 53.03,
    width: 87.14,
    height: 120.08
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1362.71,
    y: 53.03,
    width: 87.13,
    height: 120.08
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1433.73,
    y: 54.88,
    width: 46.52,
    height: 116.38
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1464.14,
    y: 53.03,
    width: 87.14,
    height: 120.08
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1530.02,
    y: 54.88,
    width: 83.55,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1580.41,
    y: 54.88,
    width: 98.91,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1659.51,
    y: 54.88,
    width: 88.58,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1733.04,
    y: 53.03,
    width: 86.87,
    height: 120.08
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1804.87,
    y: 54.88,
    width: 79.06,
    height: 116.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    y: 184.83,
    width: 879.67,
    height: 42.96
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1175.87,
    y: 184.83,
    width: 708.96,
    height: 42.96
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 852.46,
    width: 350.63,
    height: 249.31
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 857.75,
    y: 98.44,
    width: 340.05,
    height: 252.23
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    y: 284.92,
    width: 1884.83,
    height: 383.54
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmalogo);
export default __webpack_public_path__ + "static/media/smalogo.2e7e50f9.svg";
export { ForwardRef as ReactComponent };